<div class="informe-empleados">
  <div *ngIf="data">
    <!-- Sección de KPIs -->
    <div class="seccion-kpis">
      <div class="tarjeta-kpi">
        <div class="etiqueta-kpi">Ventas Totales</div>
        <div class="valor-kpi">{{ data.kpis.ventasTotales | currency: 'EUR': 'symbol': '1.2-2' }}</div>
        <div class="unidad-kpi">€</div>
      </div>

      <div class="tarjeta-kpi">
        <div class="etiqueta-kpi">Horas Ocupadas</div>
        <div class="valor-kpi">{{ data.kpis.horasOcupadas | number: '1.1-1' }}</div>
        <div class="unidad-kpi">horas</div>
      </div>

      <div class="tarjeta-kpi">
        <div class="etiqueta-kpi">Horas Libres</div>
        <div class="valor-kpi">{{ data.kpis.horasLibres | number: '1.1-1' }}</div>
        <div class="unidad-kpi">horas</div>
      </div>

      <div class="tarjeta-kpi">
        <div class="etiqueta-kpi">Tasa de Ocupación</div>
        <div class="valor-kpi">{{ data.kpis.porcentajeOcupacion | number: '1.0-0' }}%</div>
        <div class="unidad-kpi">promedio</div>
      </div>
    </div>

    <!-- Gráfico de Ocupación por Empleado -->
    <div class="seccion-grafico" *ngIf="data.filas.length > 0">
      <h3>Ocupación por Empleado</h3>
      <div class="contenedor-grafico">
        <canvas baseChart
          [datasets]="occupancyChartData"
          [labels]="occupancyChartLabels"
          [chartType]="occupancyChartType"
          [options]="occupancyChartOptions">
        </canvas>
      </div>
    </div>

    <!-- Tabla de Desempeño -->
    <div class="seccion-tabla">
      <h3>Desempeño y Ocupación por Empleado</h3>
      <div *ngIf="data.filas.length > 0; else sinRegistros" class="tabla-responsiva">
        <table class="tabla-informe">
          <thead>
            <tr>
              <th>Empleado</th>
              <th>Ventas Totales</th>
              <th>Horas Ocupadas</th>
              <th>Horas Libres</th>
              <th>Tasa de Ocupación</th>
              <th>Ingresos/Hora</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of data.filas; trackBy: trackByEmployee">
              <td><strong>{{ row.nombreEmpleado }}</strong></td>
              <td>{{ row.ventasTotales | currency: 'EUR': 'symbol': '1.2-2' }}</td>
              <td>{{ row.horasOcupadas | number: '1.1-1' }}</td>
              <td>{{ row.horasLibres | number: '1.1-1' }}</td>
              <td>
                <div class="celda-ocupacion">
                  <div
                    class="barra-ocupacion"
                    [ngClass]="'ocupacion-' + getOccupancyColor(row.porcentajeOcupacion)"
                    [style.width.%]="row.porcentajeOcupacion">
                  </div>
                  <span class="texto-ocupacion">{{ row.porcentajeOcupacion | number: '1.0-0' }}%</span>
                </div>
              </td>
              <td class="texto-derecha">{{ row.revenuePerHora | currency: 'EUR': 'symbol': '1.2-2' }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <ng-template #sinRegistros>
        <p class="sin-datos">No hay datos de empleados disponibles</p>
      </ng-template>
    </div>
  </div>
  <div *ngIf="!data" class="sin-datos">No hay datos disponibles</div>
</div>
